export interface NotificationPreference {
  channelsAvailable: NotificationChannel[],
  channelsEnabled?: NotificationChannel[],
  event: string,
  title: string,
  group: string,
}

export enum NotificationChannel {
  'email' = 'email',
  'mobile_app' = 'mobile_app'
}
